export const PROVIDER_MANAGEMENT_DEFAULT_FILTER = {
  isActive: false
}

export const PROVIDER_MANAGEMENT_DEFAULT_SORT = {
  sortedColumn: 'name',
  sortedColumnOrder: 'ascend'
}
